import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "goenga-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit {
  @Input() public buttonLoader: boolean;

  constructor() {}

  ngOnInit() {}
}
